import request from '@/utils/request'
import qs from 'qs'

export function initGame(data) {
  return request({
    baseURL: '/chaos/api/v1',
    url: '/stock/simulator/init',
    method: 'post',
    data
  })
}

export function getMonthStockInfo(data) {
  return request({
    baseURL: '/chaos/api/v1',
    url: '/stock/simulator/month',
    method: 'post',
    data
  })
}

export function selectStock(data) {
  return request({
    baseURL: '/chaos/api/v1',
    url: '/stock/simulator/buy',
    method: 'post',
    data
  })
}

export function getMonthIncome(data) {
  return request({
    baseURL: '/chaos/api/v1',
    url: '/stock/simulator/month/income',
    method: 'post',
    data
  })
}

export function getSimulatorResult(data) {
  return request({
    baseURL: '/chaos/api/v1',
    url: '/stock/simulator/income',
    method: 'post',
    data
  })
}

export function getToolInfo(data) {
  return request({
    baseURL: '/chaos/api/v1',
    url: '/stock/simulator/props',
    method: 'post',
    data
  })
}

export function useTool(data) {
  return request({
    baseURL: '/chaos/api/v1',
    url: '/stock/simulator/props/use',
    method: 'post',
    data
  })
}

export function getUserStatus(data) {
  return request({
    baseURL: '/chaos/api/v1',
    url: '/stock/simulator/status',
    method: 'post',
    data
  })
}


export function uploadTrace(data) {
  return request({
    baseURL: process.env.REACT_APP_WOGOO_SERVER,
    url: '/appTraceStat/report',
    method: 'post',
    data: qs.stringify(data),
    header: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;'
    }
  })
}


// WEBPACK FOOTER //
// ./src/views/activity_30/api.js